<template>
  <section
    class="ai-visibility-panel-card"
    :class="{
      'ai-visibility-panel-card--padded': padded,
      'ai-visibility-panel-card--flush': flush,
    }"
  >
    <slot />
  </section>
</template>

<script>
export default {
  name: 'PanelCard',
  props: {
    padded: {
      type: Boolean,
      default: true,
    },
    flush: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-panel-card {
  overflow: hidden;
  border: 1px solid var(--v-gray12Color-base);
  border-radius: 8px;
  background: var(--v-cardBg-base);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.03);
  min-height: 330px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.ai-visibility-panel-card--padded {
  padding: 20px;
}

.ai-visibility-panel-card--flush {
  padding: 0;
}
</style>
